import { useState, useEffect } from "react";
import { Login } from '../utils/usersAPI';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLoggedUser } from "../features/userSlice";
import { Button, TextField, Grid, Typography, Container, IconButton, FormControlLabel } from '@mui/material';
import { AppbarContainer, AppbarHeader } from '../styles/headerStyle';
import { PersonAdd } from "@mui/icons-material";
import Checkbox from "@mui/material/Checkbox";


const SignIn = () => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();


  // מאפסים את השדה של הטלפון כשיש טעות
  useEffect(() => {
    setPhone("");
  }, [error]);

  // useEffect(() => {
  //   // בדיקת פרטי משתמש מקומיים ב-Local Storage
  //   const storedUser = localStorage.getItem('loggedUser');
  //   if (storedUser) {
  //     dispatch(setLoggedUser(JSON.parse(storedUser)));
  //     navigate('/');
  //   }
  // }, [dispatch, navigate]);

  // useEffect(() => {
  //   setPassword("");
  // }, [error]);

  const handleClickReturnBack = () => {
    try {
      navigate("/");
    } catch {
      setError(error.message);
      console.log("page not found");
    }
  };

  const handleClickLogin = () => {
    // בדיקה שכל השדות מלאים
    if (email === "" || phone === "") {
      setError("חובה למלא את כל השדות");
    }
    // ולידציה למייל
    else if (!/\S+@\S+\.\S+/.test(email)) {
      setError("כתובת האימייל אינה חוקית");
    }
    // אפשר להוסיף ולידציה בסיסית לטלפון
    else if (!/^[0-9]{9,10}$/.test(phone)) {
      setError("מספר טלפון לא חוקי");
    }
    else {
      const user = {
        Email: email,
        Phone: phone,   // 🔹 שולחים Phone במקום Password
      };

      Login(user).then(res => {
        if (res.status === 200) {
          console.log('!!', res.data);
          dispatch(setLoggedUser(res.data));

          // ✅ שמירה ב-localStorage כדי שנוכל להגן על /admin גם אחרי רענון
          localStorage.setItem("loggedUser", JSON.stringify(res.data));
          localStorage.setItem("isAdmin", res.data.tipeUser === "admin" ? "true" : "false");


          if (res.data.tipeUser === "admin") {
            navigate('/admin');
          } else {
            navigate('/');
          }
        } else {
          setError("אחד מהנתונים שגוי");
        }
      }).catch(() => {
        setError("אירעה שגיאה בהתחברות");
      });
    }
  };

  const handleChangeEmail = (event) => {
    setError("");
    let value = event.target.value;
    setEmail(value);
  };

  const handleChangePhone = (event) => {
    setError("");
    setPhone(event.target.value);
  };

  return (
    <>
      {/* <AppbarContainer>
        <AppbarHeader>Welcome to Shine's Stock</AppbarHeader>
      </AppbarContainer> */}
      <Container maxWidth="xs"
        //   sx={{
        //   maxWidth: 830,   // רוחב מקסימלי
        //   width: "100%",   // שלא יתחרבש במסכים קטנים
        //   mx: "auto",      // margin-inline: auto -> מרכז אותו אופקית
        // }} 
        style={{ marginTop: '140px' }}>
        <Typography variant="h4" align="center" gutterBottom>
          התחברות משתמש קיים
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="כתובת מייל"
              name="email"
              type="email"
              fullWidth
              onChange={handleChangeEmail}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="מספר טלפון"
              name="phone"
              type="tel"
              fullWidth
              value={phone}
              onChange={handleChangePhone}
            />
            <FormControlLabel
              control={<Checkbox value="remember" style={{ color: "black" }} />}
              label="זכור אותי"
            />
          </Grid>
        </Grid>
        <Button type="button" variant="contained" color="primary" fullWidth onClick={handleClickLogin}>
          התחברות
        </Button>

        {error && <Typography color="error">{error}</Typography>}
        <br></br>
        {/* <Typography variant="body2" align="center" gutterBottom>
          <br></br>

          <Link to="/forgot-password">שכחת סיסמה?</Link>
        </Typography> */}

        {/* <Typography variant="h5" align="center" gutterBottom>
          <br></br>
          <br></br>

          הרשמה למשתמש חדש
          <Button
            color="inherit"
            component={Link}
            to="/signUp"
            startIcon={<PersonAdd style={{ fontSize: 40 }} />}
          >
          </Button> */}
        {/* <Button color='inherit' component={Link} to="/signUp"></Button> */}
        {/* </Typography> */}
        <Typography variant="h5" align="center" gutterBottom>
          <br />
          <br />

          <Button
            color="inherit"
            component={Link}
            to="/signUp"
            endIcon={<PersonAdd style={{ fontSize: 40, marginInlineStart: 8 }} />}
            sx={{
              color: "#0b071df6",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#e91e63"
              }
            }}

          >
            הרשמה למשתמש חדש
          </Button>
        </Typography>


      </Container>
    </>
  );
};

export default SignIn;
